$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');
  fixFeatureButton();
  createCustomToggle();
  modifySignup();
  contentMarginTop();
});

// Style Feature Button
function fixFeatureButton() {
  $('.featureLineupContainer').each((i, element) => {
    const $element = $(element);

    lineupButtonsGrid($element);
  });
}

function lineupButtonsGrid(lineup) {
  const containerSize = lineup.width();
  const buttonContainer = lineup.find('.featureLineup-buttons.subContainer');
  const icons = buttonContainer.find('.featureLineup-social');
  const buttons = buttonContainer.find('.featureLineup-buynow');

  // if icons length + buttons length is greater than containerSize then add class "column" to buttonContainer
  if (icons.width() + buttons.width() > containerSize - 20) {
    buttonContainer.addClass('column');
  }

  // remove icons if there 0 children

  if (!icons.children().length) {
    icons.remove();
  }
}

function createCustomToggle() {
  $.each(new Array(3), function () {
    $('.header .mobile-nav-toggle').append('<span class="toggle-line"></span>');
  });
}

// Calculate content margin top
function contentMarginTop() {
  function updateContentMargin() {
    setTimeout(() => {
      const headerHeight = $('header').outerHeight() || 0;
      const generalMessageHeight = $('.generalmessage').outerHeight() || 0;
      const isHomepage = $('body').hasClass('homepage');
      const isScrolled = $('body').hasClass('saffireWindowScrolled');
      const isMobile = window.innerWidth <= 1000;

      let marginTop = headerHeight;

      if (!isHomepage && isMobile) {
        marginTop += 30;
      } else if (!isHomepage && isScrolled) {
        marginTop += 50;
      } else if (!isHomepage) {
        marginTop += 80;
      } else if (isHomepage && isScrolled) {
        marginTop -= generalMessageHeight;
      }
      $('.content').css('margin-top', marginTop + 'px');
    }, 200);
  }

  $(document).ready(updateContentMargin);
  $(window).on('load scroll resize', updateContentMargin);
}

function modifySignup() {
  const signupWidget = $('.tier-three .emailSignup');

  signupWidget.each(function () {
    const $this = $(this);
    const inputField = $this.find('.emailInputField');
    const submitButton = $this.find('.emailInputSubmit');

    $this.find('.emailSignupText').replaceWith(`
      <div class="emailSignupTextContainer">       
        <h6>GET THE LATEST</h6>
        <h3>DEALS AND UPDATES</h3>     
      </div>`);

    $(inputField.add(submitButton)).wrapAll('<div class="signup-form"></div>');

    inputField
      .find('.inputFieldTextbox')
      .val('')
      .attr('placeholder', 'Enter email')
      .attr('aria-label', 'Enter email');

    submitButton.find('.emailSubmitButton').text('subscribe');
  });
}
